import Vue from 'vue'
import Vuex from 'vuex'
import { getAllLeadProjet, abandonLead, addRappel, resetPassword, deleteRdv, modifyVehicule, addVehicule, addRdv, checkCredentials, getUserProjets, getLeadProjets, changePassword, getStatistiques, updateRdvLead, getDetailLead, updateLead, createLead, linkLeadToVendeur, getCreneauxVendeur, deleteVehicule, checkLogged, getMedias, getNotifs, updateNotif, disableNotif, checkTokenAuthent, envoiLienReprise } from '../api/media.api';
import i18n from '../i18n';
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat';
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loader:false,
    auth:false,
    lang: 'fr',
    user:{},
    projets:{},
    leads: {},
    stats: {
      classement: "",
      leads_affectes: "",
      leads_traites: "",
      rdv: "",
      rdv_a_confirmer: "",
      rdv_venu: "",
      passages: "",
      passages_venus: "",
      ventes: "",
    },
    userPlanning:"",
    passagePlanning: "",
    detailLead: {},
    creneauxVendeurs: {},
    createdLeadId:"",
    routeTo: {},
    routeFrom: {},
    medias: [],
    notifs:[],
    notifsUnseenCount:0,
    resetPass: {},
  },
  mutations: {
    setAuth(state, value){
      state.auth = value
    },
    setUser(state, payload){
      state.user = payload
    },
    setProjects(state, payload){
      const projects = []
      payload.forEach((projet) => {
        if(projet.statut == "A_VENIR"){
          projects.push(projet)
        }
      })
      state.projets = projects
    },
    setLeads(state, payload){
      payload.forEach((lead, index) => {
        addStatutToLead(lead);
        if(lead.rdv.length > 0 && lead.rdv[0].venu === null){
          lead.rdv[0].venu = -1
        }
        if(lead.rdv.length > 0 && lead.rdv[0].vendu === null){
          lead.rdv[0].vendu = -1
        }
        if(lead.rdv.length > 0 && lead.rdv[0].type_vente === null){
          lead.rdv[0].type_vente = -1
        }
        if(lead.rdv.length > 0 && lead.rdv[0].est_physique === null){
          lead.rdv[0].est_physique = -1
        }
      })
      state.leads = payload
    },
    setStatut(state, lead){
      const leadToChange = state.leads.find(e => e.code_lead == lead.code_lead)
      addStatutToLead(lead)
      Object.assign(leadToChange, lead);
    },
    setLoader(state, value){
      state.loader = value
    },
    setLang(state, lang){
      i18n.locale = lang
      state.lang = lang
    },
    clearLeads(state, payload){
      state.leads = {},
      state.stats = {
        classement: "",
        leads_affectes: "",
        leads_traites: "",
        rdv: "",
        rdv_a_confirmer: "",
        rdv_venu: "",
        passages: "",
        passages_venus: "",
        ventes: ""
      }
    },
    getDisconnected(state, payload){
      state.auth = false,
      state.user = {},
      state.projets = {}
    },
    changeLead(state, lead){
      const leadToChange = state.leads.find(e => e.code_lead == lead.code_lead);
      Object.assign(leadToChange, lead);
    },
    setStats(state, payload){
      state.stats.passages = payload.nb_passages_confirmes
      state.stats.passages_venus = payload.nb_venu_passages_confirmes
      const userPlanning = payload.plannings.find(e => e.id_vendeur == state.user.id )
      const passagePlanning = payload.plannings.find(e => !e.id_vendeur)
      state.passagePlanning = passagePlanning.id;
      state.userPlanning = userPlanning.id;
      state.stats.leads_affectes = parseInt(userPlanning.nb_leads_vendeur)
      state.stats.leads_traites = parseInt(userPlanning.nb_leads_vendeur - userPlanning.nb_leads_vendeur_a_traiter)
      state.stats.rdv = parseInt(userPlanning.nb_rdv_confirmes)
      state.stats.rdv_a_confirmer = parseInt(userPlanning.nb_rdv_a_confirmer)
      state.stats.rdv_venu = parseInt(userPlanning.nb_venu_rdv_confirmes)
      state.stats.ventes = parseInt(userPlanning.nb_ventes_rdv_confirmes)
      //calcul classement
      const PlanningsVendeurs = payload.plannings;
      //enleve le planning des passages
      PlanningsVendeurs.pop();
      //get du nbre de vendeurs
      const nbVendeurs = PlanningsVendeurs.length
      PlanningsVendeurs.sort(function(a, b){
        return parseInt(a.nb_ventes_rdv_confirmes) - parseInt(b.nb_ventes_rdv_confirmes)
      })
      PlanningsVendeurs.reverse()
      //get position du vendeur
      const index = PlanningsVendeurs.findIndex((e) => e.id_vendeur == state.user.id);
      state.stats.classement = (index +1)+"/"+ nbVendeurs
    },
    setDetailLead(state, payload){
      state.detailLead = payload
    },
    setCreneauxVendeur(state, payload){
      state.creneauxVendeurs = payload
    },
    setCreatedLeadId(state, leadId){
      state.createdLeadId = leadId
    },
    setRoute(state, payload){
      state.routeTo = payload.to
      state.routeFrom = payload.from
    },
    setMedias(state, payload){
      state.medias = payload
    },
    checkTokenAuthent(state, payload){
      state.resetPass = payload
    },
    setNotifs(state, payload){
      const notifs = setNewDureeNotif(payload.data);
      const notifsProjets = notifs.filter((e) => e.code_projet == payload.code_projet)
      const finalNotif = [];
      //check que le lead rattaché a la notif existe toujours
      notifsProjets.forEach((notif) => {
        const lead = state.leads.find((e)=> e.id == notif.id_lead)
        if(lead){
          finalNotif.push(notif)
        }
      })
      state.notifs = finalNotif
    },
    setNotifRead (state, notifId) {
      const notifIndex = state.notifs.findIndex((e) => e.id_notification == notifId);
      state.notifs[notifIndex].lu = true;
    },
    setNotifSeen(state, notifications){
      notifications.forEach((notif) => {
        const notifIndex = state.notifs.findIndex((e) => e.id_notification == notif.id_notification);
        state.notifs[notifIndex].vu = true;
      })
      state.unSeenNotifs = 0;
    },
    setUnseenNotifs(state, number) {
      state.unSeenNotifs = number;
    }
  },
  actions: {
    async sendRepriseLink({commit}, payload){
      try {
        const response = await envoiLienReprise(payload);
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getAuth({commit}, payload){
      try {
        const response = await checkCredentials(payload);
        if(response.data.success){
          commit('setAuth', true)
          commit('setUser', response.data.result)
        }
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async checkLogged({commit}, payload) {
      try {
        const response = await checkLogged(payload);
        if(response.data != false){
          commit('setUser', await response.data)
          commit('setAuth', true)
        }
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getProjets({commit, state}, payload){
      try {
        const response = await getUserProjets(state.user.id, payload);
        if(response.data.success){
          if(response.data.result.length == 0){
            router.push({name: "ErrorInactive"})
          } else {
            commit('setProjects', response.data.result)
          }
          
        }
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getLeadProjets({commit, state}, payload){
      try {
        let codeProjet = payload.codeProjet;
        if(state.user.type == "EXTERNE"){
          var response = await getLeadProjets(state.user.id, codeProjet, {});
        } else {
          var response = await getAllLeadProjet(codeProjet, {});
       }
        if(response.data.success){
          
          commit('setLeads', response.data.result)
        }
      } catch (error) {
        //router.push({name: "Error404"})
      }
    },
    async getAllLeadProjet({commit, state}, payload) {
      try {
        let codeProjet = payload.codeProjet;
        const response = await getAllLeadProjet(codeProjet, {});
        if(response.data.success){
          commit('setLeads', response.data.result)
        }
      } catch (error) {
        
      }
    },
    async changePassword({commit, state}, payload){
      try {
        const response = await changePassword(payload);
        return new Promise((resolve, reject) => {
          resolve(response);
        })
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getStatistiques({commit, state}, payload){
      try {
        let codeProjet = payload.codeProjet;
          const response = await getStatistiques(codeProjet, {});
          //console.log(response)
          commit('setStats', response.data.result)
      } catch (error) {
        //console.log('burp')
        //router.push({name: "Error404"})
      }
    },
    async updateRdv({commit, state}, payload){
      try {
        if(payload.data.est_venu === 0 || payload.data.est_venu === -1){
          payload.data.est_venu = null
        } else if(payload.data.est_venu === true){
          payload.data.est_venu = "OUI"
        } else if(payload.data.est_venu === false){
          payload.data.est_venu = "NON"
        }

        if(payload.data.avec_vente === 0 || payload.data.avec_vente === -1){
          payload.data.avec_vente = null
        } else if(payload.data.avec_vente === true){
          payload.data.avec_vente = "OUI"
        } else if(payload.data.avec_vente === false){
          payload.data.avec_vente = "NON"
        }

        if(payload.data.financement === 0 || payload.data.financement === -1){
          payload.data.financement = null
        } else if(payload.data.financement === true){
          payload.data.financement = "OUI"
        } else if(payload.data.financement === false){
          payload.data.financement = "NON"
        }


        if(payload.data.VN_VO_VD === 0 || payload.data.VN_VO_VD === -1){
          payload.data.VN_VO_VD = null
        }
        if(payload.data.est_physique === 0 || payload.data.est_physique === -1){
          payload.data.est_physique = null
        }

        const response = await updateRdvLead(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getDetailLead({commit, state}, code_lead){
      try {
        const response = await getDetailLead(code_lead, {})
        if(response.data.success){
          commit('setDetailLead', response.data.result)
        } else {
          console.log(response, 'echec')
        }
        
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async updateLead({commit, state}, payload){
      try {
        const response = await updateLead(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async createLead({commit, state}, payload){
      try {
        const response = await createLead(payload)
        commit('setCreatedLeadId', response.data.result.id)
        let leadLinking = {
          code_lead: response.data.result.code_lead,
          id_vendeur: state.user.id,
          id_utlisateur: state.user.id
        }
        try {
          const response2 = await linkLeadToVendeur(leadLinking)
        } catch (error) {
          router.push({name: "Error404"})
        }
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getCreneauxVendeur({commit, state}, code_projet){
      try {
        const response = await getCreneauxVendeur(state.user.id, code_projet, {})
        commit('setCreneauxVendeur', response.data.result)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async addRdvToLead({commit}, rdv){
      try {
        if(rdv.est_venu === 0){
          rdv.est_venu = null
        } else if(rdv.est_venu === true){
          rdv.est_venu = "OUI"
        } else if(rdv.est_venu === false){
          rdv.est_venu = "NON"
        }

        if(rdv.avec_vente === 0){
          rdv.avec_vente = null
        } else if(rdv.avec_vente === true){
          rdv.avec_vente = "OUI"
        } else if(rdv.avec_vente === false){
          rdv.avec_vente = "NON"
        }
        const response = await addRdv(rdv)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async addVehicule({commit}, payload) {
      try {
        if(payload.data.financement === 0){
          payload.data.financement = null
        } else if(payload.data.financement === true){
          payload.data.financement = "OUI"
        } else if(payload.data.financement === false){
          payload.data.financement = "NON"
        }
        if(payload.data.vo_vn_vd){
          if(payload.data.vo_vn_vd === 0){
            payload.data.vo_vn_vd = null
          }
        }
        const response = await addVehicule(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async modifyVehicule({commit}, payload) {
      try {
        if(payload.data.financement === 0){
          payload.data.financement = null
        } else if(payload.data.financement === true){
          payload.data.financement = "OUI"
        } else if(payload.data.financement === false){
          payload.data.financement = "NON"
        }
        if(payload.data.vo_vn_vd){
          if(payload.data.vo_vn_vd === 0){
            payload.data.vo_vn_vd = null
          }
        }
        const response = await modifyVehicule(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async deleteVehicule({commit}, payload){
      try {
        const response = await deleteVehicule(payload)
      } catch (error) {
        
      }
    },
    async deleteRdv({commit}, payload){
      try {
        const response = await deleteRdv(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
      
    },
    async resetPassword({commit}, payload){
      try {
        const response = await resetPassword(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
      
    },
    async addRappel({commit}, payload){
      try {
        const response = await addRappel(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async disableNotif({commit}, payload){
      try {
        const response = await disableNotif(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async abandonLead({commit}, payload){
      try {
        const response = await abandonLead(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getMedias({commit}, payload) {
      try {
        const response = await getMedias(payload)
        commit('setMedias', response.data.data)
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getNotifs({commit}, payload) {
      try {
        const response = await getNotifs(payload)
        commit('setNotifs', {data: response.data.result, code_projet: payload.code_projet})
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async getNewNotifs({commit, state, dispatch}, payload) {
      try {
        if(payload.code_projet){
          const response = await getNotifs(payload)
          const newNotifs = response.data.result;
          const notifsProjetsTest = newNotifs.filter((e) => e.code_projet == payload.code_projet)
          const finalNotif = [];
          //check que le lead rattaché a la notif existe toujours
          notifsProjetsTest.forEach((notif) => {
            const lead = state.leads.find((e)=> e.id == notif.id_lead)
            if(lead){
              finalNotif.push(notif)
            }
          })
          if(finalNotif.length > state.notifs.length){
            var unseenNotifs = finalNotif.length - state.notifs.length
            dispatch('getLeadProjets', {codeProjet: payload.code_projet}).then((e) => {
              dispatch('getStatistiques', {codeProjet : payload.code_projet}).then((e) => {
                dispatch('getNotifs', payload)
                commit('setUnseenNotifs', unseenNotifs)
              })
            })
          }
        }
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async refreshData({commit, dispatch}, payload){
      try {
          await dispatch('getLeadProjets', {codeProjet: payload.code_projet}).then(async (e) => {
            await dispatch('getMedias', payload).then(async (e) => {
              await dispatch('getStatistiques', {codeProjet : payload.code_projet}).then(async (e) => {
                await dispatch('getNotifs', payload)
              })
            })
          })
      } catch (error) {
        router.push({name: "Error404"})
      }
    },
    async setNotifRead ({commit}, notifId) {
      try {
        const payload = {
          id_notification: notifId,
          lu : "OUI" 
        }
        const response = await updateNotif(payload)
      } catch (error) {
        router.push({name: "Error404"})
      }
      commit('setNotifRead', notifId)
    },
    async checkTokenAuthent({commit}, payload){
      try {
        const response = await checkTokenAuthent(payload)
        if(response.data.success){
          commit('checkTokenAuthent', response.data.result)
        } else {
          commit('checkTokenAuthent', false)
        }
        
      } catch (error) {
        
      }
    },
    setNotifSeen({commit}, payload){
      payload.forEach((notification) => {
        const payloadSeen = {
          id_notification: notification.id_notification,
          vu : "OUI" 
        }
        const response = updateNotif(payloadSeen)
      })
      commit('setNotifSeen', payload)
    },
    setRoute({commit}, payload){
      commit('setRoute', payload)
    },
    setLoader({commit}, value){
      commit('setLoader', value)
    },
    setStatut({commit}, payload){
      commit('setStatut', payload)
    },
    clearLeads({commit}, payload){
      commit('clearLeads', payload)
    },
    getDisconnected({commit}, payload){
      commit('getDisconnected', payload)
    },
    setLang({commit}, lang){
      commit('setLang', lang)
    },
    changeLead({commit}, lead){
      commit('changeLead', lead)
    },
  },
  getters: {
    getUnseenNotifs: (state) => {
      const unSeenNotifs = state.notifs.filter((e) => e.vu == false)
      return unSeenNotifs.length
    },
    //getter pour vérifier qu'un lead existe
    isLeadExists: (state) => (lead_id) => {
      const lead = state.leads.find((e) => e.id == lead_id)
      if(lead){
        return true
      } else {
        return false
      }
    },
    //Getter des leads avec un rendez-vous  -- Retourne un array (clé: date du rdv, value: array de leads ayant le rdv ce jour)
    leadsWithRdv: state => {
      const arrayRdv = {};
      state.leads.forEach((lead) =>{
        if(Object.keys(lead.rdv).length > 0 && lead.rdv[0].date_rendez_vous != null) {
          const dateHeure = lead.rdv[0].date_rendez_vous;
          const dateArray = dateHeure.split(" ");
          if(!arrayRdv[dateArray[0]]){
            arrayRdv[dateArray[0]] = []
          }
          arrayRdv[dateArray[0]].push(lead);
        }
      })
      return arrayRdv;
    },
    //Getter des dates disponibles pour setter des rendez vous
    getDateDispo: state => {
      const Creneaux = state.creneauxVendeurs;
      const dates = [];
      Object.entries(Creneaux).forEach(entry => {
        const [key, value] = entry;
        if(value.is_disponible){
          dates.push(key);
        }
      });
      return dates;
    },
    //get les créneaux disponibles
    getCreneauxDispo: (state, getters) => (date) => {
      return state.creneauxVendeurs[date].creneaux.filter(e => e.is_disponible)
    },
    //getter des dates dispo classées
    getAllRdvDate: (state, getters) => {
        const leadRdv = getters.leadsWithRdv;
        const dateRdv = Object.keys(leadRdv);
        const finalDates = Array.from(new Set(dateRdv))
        finalDates.sort(function(a,b){
          let arrayA = a.split('/');
          let arrayB = b.split('/');
          return new Date(arrayB[2], arrayB[1], arrayB[0]) - new Date(arrayA[2], arrayA[1], arrayA[0]);
        });
        return finalDates
    },
    //Getter des leads ayant une clé de rdv ou des leads a recontacter
    leadsFullRdv: state => {
      return state.leads.filter((lead) => { 
        if(lead.statut == 'A_RECONTACTER' || lead.statut == 'A_RECONTACTER_VENDEUR'){
          return lead
        } else {
          if(Object.keys(lead.rdv).length > 0){
            return lead
          }
        }
      })
    },
    //retourne les leads Nouveaux (sans rdv)
    newLeads: (state, getters) => {
      return state.leads.filter((lead) => {
        if(lead.rdv.length == 0){
          return lead;
        }
      })
    },
    //Getter de recherche de leads "Nouveau" dépendant de leur nom prénom et code pour prise de rdv
    searchNewLeads: (state, getters) => (text) => {
      const leadToFilter = getters.newLeads;
      const leads = [];
      leadToFilter.forEach((lead, index) => {           
        if(lead.nom.match(new RegExp(text, 'i')) || lead.prenom.match(new RegExp(text, 'i')) || lead.code_lead.match(new RegExp(text, 'i'))){
          leads.push(lead);
        }
      })
      return leads
    },
    //Getters des lead a afficher dans la TODO
    leadsTodo: (state, getters) => {
      let leads = [];
      const leadsFullRdv = getters.leadsFullRdv;
        leadsFullRdv.forEach(element => {
            const lead = element;
            if(lead.statut == 'A_RECONTACTER' || lead.statut == 'A_RECONTACTER_VENDEUR'){
              leads.push(lead)
            } else {
              let rdvs = element.rdv;
              rdvs.forEach(element => {
                  dayjs.extend(customParseFormat)
                  //montre juste les rdv dont la date est passé ou les rendez vous du jour, pas les futurs rdv
                  if(element.date_rendez_vous && dayjs().isAfter(dayjs(element.date_rendez_vous, "DD/MM/YYYY HH:mm")) || element.date_rendez_vous == null ){
                      if(element.venu === false){
                        return;
                      } else if (element.venu === true && element.vendu === false){
                        return;
                      } else if (element.venu === true && element.vendu === true && (element.type_vente !== null && element.type_vente !== -1 && element.type_vente !== 0) && (element.financement !== null && element.financement !== -1 && element.financement !== 0)){
                        return;
                      } else {
                        if(element.vendu === null || element.vendu === 0){ element.vendu = -1 }
                        if(element.venu === null || element.venu === 0){ element.venu = -1 }
                        if(element.type_vente === null || element.type_vente === 0){ element.type_vente = -1 }
                        if(element.financement === null || element.financement === 0){ element.financement = -1 }
                        if(!leads.includes(lead)){
                          leads.push(lead)
                        }  
                      }
                  }
              });
            }
            
            
      });
      const sortLeads = leads.sort((a, b) => (a.finalStatut > b.finalStatut) ? 1 : ((b.finalStatut > a.finalStatut) ? -1 : 0))
      return sortLeads;
    },
    //Getter de filtrage des leads - return Array de leads
    getFilteredLeads: (state) => (statut, text, source) => {
      if(!statut && !text && !source){
        return state.leads
      } else {
        let leadsToFilter = state.leads;
        if(text) {
          const leads = []; 
          leadsToFilter.forEach((lead) => {
            if(lead.nom.match(new RegExp(text, 'i')) || lead.prenom.match(new RegExp(text, 'i')) || lead.code_lead.match(new RegExp(text, 'i'))){
              leads.push(lead);
            }
          })
          leadsToFilter = leads;
        }
        if(statut) {
          if(statut.subStatut){
            leadsToFilter = leadsToFilter.filter((e) => e.finalSubStatut);
            leadsToFilter = leadsToFilter.filter((e) => e.finalSubStatut.includes(statut.subStatut))

          } else {
            leadsToFilter = leadsToFilter.filter((e) => e.finalStatut == statut.statut)
          }
        }
        if(source) {
          if(source == "Non Inscrit"){
            leadsToFilter = leadsToFilter.filter((e) => e.source_inscription === null)
          } else {
            leadsToFilter = leadsToFilter.filter((e) => e.source_inscription == source)
          }
        }

        

        return leadsToFilter
        
      }
    },
    //check if lead exists - return boolean
    getLeadById: (state) => (id) => {
      return state.leads.find((e) => e.id == id)
    },
    //getters pour récupérer toutes les sources d'inscription - return Array
    getInscriptionSourceList: (state) => {
      const leads = state.leads;
      const sourceInscription = [];
      leads.forEach((lead) => {
        if(!lead.source_inscription && !sourceInscription.includes("Non Inscrit")){
          sourceInscription.push("Non Inscrit")
        }
        if(lead.source_inscription && !sourceInscription.includes(lead.source_inscription)){
          sourceInscription.push(lead.source_inscription)
        }
      })
      return sourceInscription
    },
    //getters pour récupérer les statuts disponibles dépendant de la liste des leads - return Array
    getStatutList: (state) => {
        const leads = state.leads;
        let subStatuts = [];
        let statuts = [];
        //Pour chaque leads
        leads.forEach((lead) => {
          // si le lead a des sous statuts
          if(lead.finalSubStatut){
            lead.finalSubStatut.forEach((sub) => {
              //on créé l'objet
              let subItem = {}
              subItem.subStatut = sub
              subItem.text = i18n.t('messages.statuts.'+sub)
              //on l'ajoute a l'array
              subStatuts.push(subItem)
            })
            //Efface les doublons
            subStatuts = subStatuts.reduce((acc, current) => {
              const x = acc.find(item => item.subStatut === current.subStatut);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);
          } else {
            //on créé l'objet
            let subItem = {}
            subItem.statut = lead.finalStatut
            subItem.text = i18n.t('messages.statuts.'+lead.finalStatut)
            //On l'ajoute au tableau
            statuts.push(subItem)
            //Efface les doublons
            statuts = statuts.reduce((acc, current) => {
              const x = acc.find(item => item.statut === current.statut);
              if (!x) {
                return acc.concat([current]);
              } else {
                return acc;
              }
            }, []);
          }
        })
        //On fusionne le tableau des statuts avec celui des sous statuts
        const statutArray = subStatuts.concat(statuts)
        return statutArray
    }
  },
  modules: {
  }
})

//Fonction Utilitaire de mise en place des Statuts/Sous statuts
function addStatutToLead(lead){
  try {
  
    if(lead.statut == "RDV_PRIS"){
      if(lead.rdv.length > 0 && lead.rdv[0].id){
          if(!lead.rdv[0].date_rendez_vous){
            if(lead.rdv[0].venu !== null && lead.rdv[0].venu !== -1 && lead.rdv[0].venu !== 0 && lead.rdv[0].vendu !== null && lead.rdv[0].vendu !== -1 && lead.rdv[0].vendu !== 0){
              lead.finalStatut = "passageQualifier"
              const subStatut = [];
              if(lead.rdv[0].venu === true) {
                subStatut.push("venu");
                if(lead.rdv[0].vendu === true){
                  if(lead.rdv[0].type_vente === "VO"){
                    subStatut.push("achat_vo");
                  }else if(lead.rdv[0].type_vente === "VN"){
                    subStatut.push("achat_vn");
                  }else if(lead.rdv[0].type_vente === "VD"){
                    subStatut.push("achat_vd");
                  }else {
                    subStatut.push("achat");
                  }
                } else if(lead.rdv[0].vendu === false) {
                  subStatut.push("noachat");
                }
              } else if(lead.rdv[0].venu === false) {
                subStatut.push("novenu");
              }
              lead.finalSubStatut = subStatut;
            } else {
              lead.finalStatut = "passage"
            }
          } else {
            if(lead.rdv[0].venu !== null && lead.rdv[0].venu !== -1 && lead.rdv[0].venu !== 0 && lead.rdv[0].vendu !== null && lead.rdv[0].vendu !== -1 && lead.rdv[0].vendu !== 0){
              lead.finalStatut = "rdvQualifier"
              const subStatut = [];
              if(lead.rdv[0].venu === true) {
                subStatut.push("venu");
                if(lead.rdv[0].vendu === true){
                  if(lead.rdv[0].type_vente === "VO"){
                    subStatut.push("achat_vo");
                  }else if(lead.rdv[0].type_vente === "VN"){
                    subStatut.push("achat_vn");
                  }else if(lead.rdv[0].type_vente === "VD"){
                    subStatut.push("achat_vd");
                  }else {
                    subStatut.push("achat");
                  }
                } else if(lead.rdv[0].vendu === false) {
                  subStatut.push("noachat");
                }
              } else if(lead.rdv[0].venu === false) {
                subStatut.push("novenu");
              }
              lead.finalSubStatut = subStatut;
            } else {
              lead.finalStatut = "rdvaQualifier"
              if(lead.finalSubStatut){
                lead.finalSubStatut = [];
              }
              if(lead.rdv[0].venu === false){
                lead.finalStatut = "rdvQualifier"
                lead.finalSubStatut = ["novenu"]
              }
              
            }
          }
      } else {
        lead.finalStatut = "nouveau"
        if(lead.finalSubStatut){
          lead.finalSubStatut = [];
        }
      }
    } else if(lead.statut == 'ABANDONNER_VENDEUR' || lead.statut == "ABANDONNER"){
      lead.finalStatut = "echec"
      if(lead.finalSubStatut){
        lead.finalSubStatut = [];
      }
    } else if(lead.statut == "NOUVEAU"){
      lead.finalStatut = "nouveau"
      if(lead.finalSubStatut){
        lead.finalSubStatut = [];
      }
    } else if (lead.statut == 'EN_ATTENTE_VENDEUR' || lead.statut == 'EN_ATTENTE'){
      lead.finalStatut = "wait"
    } else if (lead.statut == 'A_RECONTACTER' || lead.statut == 'A_RECONTACTER_VENDEUR'){
        if(lead.motif && lead.motif == 'RENDEZ_VOUS_A_CONFIRMER' ){
          lead.finalStatut = "rdvaConfirmer"
        } else if (lead.motif && lead.motif == "INSCRIT"){
          lead.finalStatut = "ARLP"
        } else if (lead.motif && lead.motif == "RAPPEL_PLANIFIE"){
          lead.finalStatut = "ARRP"
        } else {
          lead.finalStatut = "wait"
        }
        if(lead.finalSubStatut){
          lead.finalSubStatut = [];
        }
    } else if(lead.statut == "BLACK_LIST"){
      lead.finalStatut = "black"
      if(lead.finalSubStatut){
        lead.finalSubStatut = [];
      }
    }
      
  } catch (error) {
    console.log(lead)
  }
}

//Réécris depuis cb de temps la notification a été créée
function setNewDureeNotif(notifications){
  let NotifArray = [];
  notifications.forEach((notif) => {

    switch (notif.dureeNotifType) {
      case "y":
        notif.duree = notif.dureeNotifValeur+" ans"
        break;
      case "m":
        notif.duree = notif.dureeNotifValeur+" mois"
        break;
      case "d":
        notif.duree = notif.dureeNotifValeur+" jours"
        break;
      case "h":
        notif.duree = notif.dureeNotifValeur+" heures"
        break;
      case "i":
        notif.duree = notif.dureeNotifValeur+" minutes"
        break;
      case "s":
        notif.duree = notif.dureeNotifValeur+" secondes"
        break;
      default:
        break;
    }
    NotifArray.push(notif)
  })
  return NotifArray
}
